import React, { Component } from 'react';
import { connect } from 'react-redux';

import { showNotification } from 'actions/payments';

const mapStateToProps = ({ profile, payments }) => ({
  profile,
  isShown: payments.isNotificationShown
});

const withObservePayments = (WrapedComponent) => {
  @connect(mapStateToProps, { showNotification })
  class WithObservePayments extends Component {
    UNSAFE_componentWillReceiveProps({ profile, showNotification, isShown }) {
      // console.log(1);
      // this.interval = !this.interval && setInterval(() => {
      //   console.log(profile);
      //
      //   if (profile.isLoaded && profile.tariff) {
      //     const { tariff } = profile;
      //     console.log(tariff.countDay);
      //     if (tariff.countDay <= 80 && !isShown) {
      //       showNotification();
      //     }
      //   }
      // }, 10000);
      if (profile.isLoaded && profile.tariff) {
        const { tariff } = profile;
        if (tariff.countDay <= 5 && tariff.countDay !== 0 && !isShown) {
          const psd = +localStorage.getItem('psd');
          const shouldDisplay = psd ?
            Date.now() - (24 * 3600 * 1000) >= psd : true;
          if (shouldDisplay) {
            showNotification();
          }
        }
      }
    }

    render() {
      return (
        <WrapedComponent {...this.props} />
      );
    }
  }
  return WithObservePayments;
};

export default withObservePayments;



// WEBPACK FOOTER //
// ./src/decorators/withObservePayments.js